<template>
  <v-container>
    <div class=" pb-3">
      <v-img src="@/assets/Create_Store/Banner-3.png" class="rounded-xl"  ></v-img>
    </div>
    <v-card class="container">
    <v-card elevation="0" width="100%" height="100%" style="background: #FAFAFA; box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.15); border-radius: 8px;">
      <v-card-text v-if="stepper === 1">
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon>
        <span style="font-weight: 600; font-size: 16px; line-height: 24px; color: #333333;">ข้อมูลทั่วไป</span>
        <v-col cols="12" md="12"  class="mt-6 px-0">
          <v-card
            elevation="0"
            width="100%"
            height="100%"
            style="background: #FFFFFF; border-radius: 8px;"
          >
            <v-card-text>
              <v-card
                elevation="0"
                style="border: 2px dashed #27AB9C; box-sizing: border-box; border-radius: 8px;"
                @click="onPickFile()"
              >
                <v-card-text>
                  <v-row
                    no-gutters
                    align="center"
                    justify="center"
                    style="cursor: pointer;"
                  >
                    <v-file-input
                      v-model="DataImage"
                      :items="DataImage"
                      accept="image/jpeg, image/jpg, image/png"
                      @click="event => event.target.value = null"
                      @change="UploadImage()"
                      id="file_input"
                      multiple
                      :clearable="false"
                      style="display:none"
                    >
                    </v-file-input>
                    <v-col cols="12" md="12" class="mb-6">
                      <v-row justify="center" class="pt-10">
                        <v-img
                          src="@/assets/ImageINET-Marketplace/ICONShop/uploadImg.png"
                          width="280.34"
                          height="154.87"
                          contain
                        ></v-img>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="12" class="mt-6">
                      <v-row justify="center" align="center">
                        <v-col cols="12" md="6" style="text-align: center;">
                          <span
                            style="font-size: 16px; line-height: 24px; font-weight: 400;"
                            >เพิ่มรูปภาพของคุณที่นี่</span
                          ><br />
                          <span
                            style="font-size: 16px; line-height: 24px; font-weight: 40;"
                            >หรือเลือกรูปภาพจากคอมพิวเตอร์ของคุณ</span
                          ><br />
                          <span
                            style="font-size: 12px; line-height: 16px; font-weight: 400;"
                            >(ไฟล์นามสกุล .JPEG, .PNG เพิ่มได้สูงสุด 6 รูปภาพ)</span
                          ><br />
                          <span
                            style="font-size: 12px; line-height: 16px; font-weight: 400;"
                            >
                            ไฟล์รูปควรมีขนาดไม่เกิน 2 MB</span
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
                <span style="font-size: 12px; line-height: 16px; font-weight: 400;">
                  <span style="color: red;">***</span> หมายเหตุ  รูปแรกจะเป็นรูปโปรไฟล์(Profile)
                </span>
                <div v-if="Detail.product_image.length !== 0" class="mt-4">
                <draggable v-model="Detail.product_image"  :move="onMove" @start="drag=true" @end="drag=false" class="pl-5 pr-5 row  fill-height align-center sortable-list">
                  <v-col v-for="(item, index) in Detail.product_image" :key="index" cols="12" sm="6" md="2">
                    <v-card v-if="item.type === 'image'" outlined class="pa-1" width="146" height="146">
                      <v-img :src="item.path" :lazy-src="item.url" width="136" height="136" contain>
                        <v-btn icon x-small style="float: right; background-color: #ff5252;">
                          <v-icon x-small color="white" dark @click="RemoveImage(index, item)">mdi-close</v-icon>
                        </v-btn>
                      </v-img>
                    </v-card>
                  </v-col>
                </draggable>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-row dense justify="end">
          <v-btn  dark outlined color="#27AB9C" class="pl-7 pr-7 mr-1" @click="cancle()">ยกเลิก</v-btn>
          <v-btn color="#27AB9C" class="px-8" dark @click="open()">ตกลง</v-btn>
        </v-row>
      </v-card-text>
    </v-card>
    </v-card>

    <!-- dialog confirm -->
    <v-dialog  v-model="dialog" width="400" persistent>
      <v-card align="center" class="rounded-lg">
        <v-toolbar color="#BDE7D9" dark dense elevation="0">
          <span class="flex text-center ml-5" style="font-size:20px"><font color="#27AB9C">แก้ไขข้อมูลร้านค้า</font></span>
          <v-btn
            icon
            dark
            @click="dialog = false"
            >
            <v-icon  color="#27AB9C">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <br/><br/>
        <v-card-text >
          <span>
            คุณได้ทำการแก้ไขข้อมูลร้านค้า<br/>
            คุณต้องการทำรายการนี้ ใช่ หรือไม่
          </span>
        </v-card-text>
        <v-card-actions >
       <v-container >
        <v-btn dense  dark outlined color="#27AB9C" class="pl-7 pr-7 mt-2" @click="closeModal()">ยกเลิก</v-btn>
        <v-btn dense  color="#27AB9C" class="ml-4 mt-2 pl-8 pr-8 white--text" @click="postDetailShop()">ตกลง</v-btn>
       </v-container>
      </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { Decode } from '@/services'
export default {
  data () {
    return {
      seller_shop_id: '',
      stepper: 1,

      // stepper 1
      bussinessType: '',
      DataImage: [],
      Detail: {
        product_image: []
        // shop_name_th: '',
        // shop_name_en: '',
        // shop_description: '',
        // path_logo: ''
      },
      shopName: '',
      taxNumber: '',
      urlname: '',
      descriptionShop: '',
      mobile: '',
      facebook: '',
      line: '',
      openshop: false,
      publicshop: false,
      merchant_key: '',

      // stepper 2
      first_name: '',
      last_name: '',
      shopEmail: '',
      shop_address: '',
      // ไม่ใช้แต่ต้องส่ง
      partner: false,

      dialog: false
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    }
  },
  created () {
    // this.$EventBus.$emit('changeNav')
    // this.$EventBus.$emit('changeNav', this.SelectPath)
    var shop = JSON.parse(Decode.decode(localStorage.getItem('GraczShopData')))
    this.seller_shop_id = shop.seller_shop_id
    this.getDetailShop()
    window.scrollTo(0, 0)
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/SellerShopDetailMobile/undefined-undefined' })
      } else {
        this.$router.push({ path: '/Order/SellerShopDetail/undefined-undefined' })
      }
    },
    async getDetailShop () {
      // var idshop = localStorage.getItem('shopSellerID')
      var data = {
        seller_shop_id: this.seller_shop_id
      }
      await this.$store.dispatch('actionsGraczSellerShopPage', data)
      var response = await this.$store.state.ModuleGraczShop.stateGraczSellerShopPage
      if (response.message === 'Not access this function.') {
        await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      }
      var shopDetail = response.data[0]

      // picture
      var img = shopDetail.shop_image
      for (let i = 0; i < shopDetail.shop_image.length; i++) {
        var sent = {
          path: img[i].media_path,
          name: 'default',
          type: 'image',
          id: img[i].id
        }
        this.Detail.product_image.push(sent)
      }
      // steppper 1
      this.bussinessType = shopDetail.shop_type
      this.shopName = shopDetail.shop_name
      this.taxNumber = shopDetail.tax_id
      this.urlname = shopDetail.url_name
      this.descriptionShop = shopDetail.shop_description
      this.mobile = shopDetail.shop_phone
      this.facebook = shopDetail.facebook_url
      this.line = shopDetail.line_id
      if (shopDetail.shop_status === 'active') {
        this.openshop = true
      } else {
        this.openshop = false
      }
      if (shopDetail.have_partner === 'yes') {
        this.publicshop = true
      } else {
        this.publicshop = false
      }
      this.merchant_key = shopDetail.merchant_key

      // stepper 2
      this.first_name = shopDetail.first_name
      this.last_name = shopDetail.last_name
      this.shopEmail = shopDetail.shop_email
      this.shop_address = shopDetail.shop_address

      // ไม่ใช้แต่ต้องส่ง
      if (shopDetail.partner_show === 'yes') {
        this.partner = true
      } else {
        this.partner = false
      }
    },
    // picture
    onPickFile () {
      document.getElementById('file_input').click()
    },
    UploadImage () {
      if (this.Detail.product_image.length < 6) {
        for (let i = 0; i < this.DataImage.length; i++) {
          const element = this.DataImage[i]
          const imageSize = element.size / 1024 / 1024
          if (imageSize < 2) {
            const reader = new FileReader()
            reader.readAsDataURL(element)
            reader.onload = () => {
              var resultReader = reader.result
              var url = URL.createObjectURL(element)
              if (this.Detail.product_image.length < 6) {
                this.Detail.product_image.push({
                  image_data: resultReader.split(',')[1],
                  path: url,
                  name: this.DataImage[i].name,
                  type: (this.DataImage[i].type.split('/', 1)).toString()
                })
              } else {
                this.$swal.fire({
                  icon: 'warning',
                  text: 'กรุณาเพิ่มรูปภาพไม่เกิน 6 รูป',
                  showConfirmButton: false,
                  timer: 1500
                })
              }
            }
          } else {
            this.$swal.fire({
              icon: 'warning',
              text: 'กรุณาใส่รูปที่มีขนาดน้อยกว่า 2 MB',
              showConfirmButton: false,
              timer: 1500
            })
          }
        }
      } else {
        this.$swal.fire({
          icon: 'warning',
          text: 'กรุณาเพิ่มรูปภาพไม่เกิน 6 รูป',
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    onMove ({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext
      const draggedElement = draggedContext
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      )
    },
    RemoveImage (index, val) {
      if (this.$route.query.Status === 'Edit') {
        if (val.id !== undefined) {
          this.Detail.remove_img.push({
            id: val.id
          })
        }
        this.Detail.product_image.splice(index, 1)
      } else {
        this.Detail.product_image.splice(index, 1)
      }
    },

    // action btn
    cancle () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/SellerShopDetailMobile/undefined-undefined' })
      } else {
        this.$router.push({ path: '/Order/SellerShopDetail/undefined-undefined' })
      }
    },
    open () {
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    closeModal () {
      this.dialog = false
      window.scrollTo(0, 0)
    },
    async postDetailShop () {
      this.dialog = false
      var list = []
      for (let i = 0; i < this.Detail.product_image.length; i++) {
        if (this.Detail.product_image[i].name === 'default') {
          list.push({
            id: this.Detail.product_image[i].id
          })
        } else {
          list.push({
            id: '-1',
            image_data: this.Detail.product_image[i].image_data
          })
        }
      }
      var dataEdit = {
        shop_image: list,

        // ข้อมูลเก่าที่เอามาใช้
        seller_shop_id: this.seller_shop_id,
        // stepper 1
        shop_type: this.bussinessType,
        shop_name: this.shopName,
        tax_id: this.taxNumber,
        shop_url: this.urlname,
        shop_description: this.descriptionShop,
        shop_phone: this.mobile,
        facebook_url: this.facebook,
        line_id: this.line,
        shop_status: this.openshop ? 'active' : 'inactive',
        public_show: this.publicshop ? 'yes' : 'no',
        merchant_key: this.merchant_key,
        // stepper2
        first_name: this.first_name,
        last_name: this.last_name,
        shop_email: this.shopEmail,
        shop_address: this.shop_address,
        // ข้อมูลที่ไม่อยากใช้
        have_partner: this.publicshop ? 'yes' : 'no',
        partner_show: this.partner ? 'yes' : 'no'
        // shop_shipping_type: this.shipping
      }
      await this.$store.dispatch('actionEditShop', dataEdit)
      var response = await this.$store.state.ModuleShop.stateEditShop
      if (response.code === 200) {
        this.$swal.fire({ text: 'บันทึกข้อมูลสำเร็จ', icon: 'success', timer: 2500, showConfirmButton: false })
        window.scrollTo(0, 0)
        this.Detail.product_image = []
        this.getDetailShop()
        if (this.MobileSize) {
          this.$router.push({ path: '/Order/SellerShopDetailMobile/undefined-undefined' })
        } else {
          this.$router.push({ path: '/Order/SellerShopDetail/undefined-undefined' })
        }
      } else {
        if (response.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          this.$swal.fire({ text: 'บันทึกข้อมูลไม่สำเร็จ', icon: 'error', timer: 2500, showConfirmButton: false })
        }
      }
    },
    nextStep (val) {
      this.stepper = val
    }
  }
}
</script>

<style>

</style>
